import * as React from "react";
const SvgFiRrMeterFire = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-meter-fire_svg__a)">
      <path
        fill="#062147"
        d="M10.983 22.999a1 1 0 0 1-1.164.802C4.13 22.757 0 17.793 0 12 0 5.383 5.383 0 12 0c5.347 0 10.095 3.589 11.548 8.728a1 1 0 1 1-1.923.545c-1.211-4.282-5.169-7.272-9.624-7.272C6.486 2 2 6.486 2 12a9.99 9.99 0 0 0 8.181 9.835 1 1 0 0 1 .803 1.164zM5 8v2a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0m5-1a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1m3 1v2a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0m10.124 12.923c-1.147 1.899-3.101 3.044-5.158 3.044-3.453 0-5.966-2.829-5.966-5.999 0-1.201.737-3.271 1.245-4.169.312-.553.833-.848 1.378-.829.562.034 1.048.416 1.3 1.023.037.089.2.55.251.68.119-.36.227-.95.299-1.349.136-.74.288-1.58.608-2.327.298-.696.8-.903 1.073-.964.278-.061.828-.088 1.411.43 4.269 3.781 5.466 7.301 3.559 10.46m-4.41-8.532c-.112.41-.193.856-.273 1.293-.252 1.386-.599 3.284-2.415 3.284-.762 0-1.219-.543-1.511-1.111-.28.765-.515 1.642-.515 2.111 0 1.528.863 2.868 2.138 3.541-.265-.744-.053-1.626.535-2.214l.77-1.096a.79.79 0 0 1 1.115 0l.769 1.097c.561.562.779 1.391.567 2.112a4.44 4.44 0 0 0 1.517-1.518c1.311-2.17.454-4.562-2.697-7.499"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-meter-fire_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMeterFire;
